var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-brandTile",on:{"click":_vm.handleClick}},[_c('span',[_c('img',{attrs:{"src":_vm.brand.logo,"alt":_vm.brand.name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }